module.exports = {
      id: "spotify-usage",
      viewBox: "0 0 22 22",
      url: __webpack_public_path__ + "svg-sprite-0ef3134280a050ca46b4726dfe0fed42.svg#spotify",
      toString: function () {
        return this.url;
      }
    }